import type {Company} from "@/store/api/companyApi";
import {createSlice, PayloadAction} from "@reduxjs/toolkit";

interface CompanyState {
    selectedCompany: Company | null;
}

const initialState: CompanyState = {
    selectedCompany: null,
};

const companySlice = createSlice({
    name: "company",
    initialState,
    reducers: {
        setCompany(state, action: PayloadAction<Company>) {
            state.selectedCompany = action.payload;
        },
        clearCompany(state) {
            state.selectedCompany = null;
        },
    },
});

export const {setCompany, clearCompany} = companySlice.actions;
export default companySlice.reducer;